import React, { useState } from "react";
import Tickets from "./Tickets";
import Request from "./Request";

const PastReques1 = () => {
  const [activeTab, setActiveTab] = useState("PastRequest");

  const renderComponent = () => {
    switch (activeTab) {
      case "PastRequest":
        return <Request />;
      case "Tickets":
        return <Tickets />;
      default:
        return null;
    }
  };

  return (
    <div>
      <ul className="flex px-2 bg-white w-full fixed  sm:relative">
        <li
          className={`w-full text-center border-b-2 cursor-pointer ${
            activeTab === "PastRequest" ? "border-header" : "border-grey"
          }`}
          onClick={() => setActiveTab("PastRequest")}
        >
          <span
            className={`inline-block p-3 font-bold ${
              activeTab === "PastRequest" ? "text-dark" : "text-grey"
            }`}
          >
            Past Request
          </span>
        </li>
        <li
          className={`w-full text-center border-b-2 cursor-pointer ${
            activeTab === "Tickets" ? "border-header" : "border-grey"
          }`}
          onClick={() => setActiveTab("Tickets")}
        >
          <span
            className={`inline-block p-3 font-bold ${
              activeTab === "Tickets" ? "text-dark" : "text-grey"
            }`}
          >
            Tickets
          </span>
        </li>
      </ul>

      <div className="tab-content">{renderComponent()}</div>
    </div>
  );
};

export default PastReques1;
